import React from "react";
import { Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import CollapsibleCardHeader from "../../../../../components/atoms/cardHeader/collapsibleCardHeader";
import TinyEditor from "../../../../../components/atoms/formFields/tinyEditor";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getDosageThunk } from "../../../../../store/thunks/InventoryThunk";

const TargetAnimalsDetail = ({ detail }) => {
    const dispatch = useDispatch();
  const { id } = useParams();
  const { data: crop } = useSelector((state) => state?.getDosage || {});
  console.log("target animal", detail, crop);
  return (
    <div className="card">
      <CollapsibleCardHeader
        name={"Target Animals"}
        id={"animals"}
        target={"collapse"}
      />

      <div id="collapse" className="collapse" data-parent="#animals">
        <div className="card-body">
          <div id="target_crops">
            <label className="font-weight-bolder font-size-lg mb-3 d-block h5">
              Selected Target Animals
            </label>
          </div>
          <div className="separator separator-solid my-5"></div>
          <div className="custom-radio-button-black">
            {detail?.targetAnimals?.map((animals, index) => {
              return (
                <>
                  <label
                    key={index.toString()}
                    className="status"
                    data-toggle="modal"
                    data-target="#annual_modal"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(
                        getDosageThunk({
                          animalDosageRequest: {
                            productId: id,
                            tagId: animals?.id,
                          },
                        })
                      );
                    }}
                  >
                    <input type="radio" name="radio" />
                    <div className="box">
                      <span>{animals?.name?.en}</span>
                    </div>
                  </label>
                </>
              );
            })}
          </div>
          {crop?.tagId ? (
            <Tabs defaultActiveKey="1">
              <TabPane tab={<span>English</span>} key="1">
                <TinyEditor disabled={true} value={crop?.dosage?.en || ""} />
              </TabPane>
              <TabPane tab={<span>Hindi</span>} key="2">
                <TinyEditor disabled={true} value={crop?.dosage?.hn || ""} />
              </TabPane>
              <TabPane tab={<span>Punjabi</span>} key="3">
                <TinyEditor disabled={true} value={crop?.dosage?.pb || ""} />
              </TabPane>
            </Tabs>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default TargetAnimalsDetail;
